// AppLayout.tsx
import { useDataPage } from "@/pages/data/DataPageContext";
import { Outlet } from "react-router-dom";

const DataLayout = () => {
  const { title } = useDataPage();
  return <Outlet />;
};

export default DataLayout;
